import './ProfilePost.less';
import React from 'react';
import clsx from 'clsx';
import BetbookProfileArrow from '../../../icons/svg/betbook-profile-arrow-icon-sv.svg';
import { useBetbookProfileContext } from '../BetbookProfileContext';
import RouteLink from '../../../common/routing/RouteLink';
import { toBetbookAuthorPathParams } from '../../betbook/constants';
import { nuiCtx } from '../../../common/initialization';

const ProfilePost = ({ count, label, postType, nickname, simplified, active, ...other }) => {
    const { getBetbookPostsAuthorRoute } = useBetbookProfileContext();
    const simplifiedProfileClass = 'betbook-simplified-profile-post-module-count';
    const profileClass = 'betbook-profile-post-module-count';
    const closeDialogBeforeNavigate = () => {
        nuiCtx.closeAllDialogs();
        return true;
    };
    return (
        <RouteLink
            route={getBetbookPostsAuthorRoute()}
            beforeNavigate={closeDialogBeforeNavigate}
            params={toBetbookAuthorPathParams(nickname, postType)}
            enabled={count >= 0}
            className={clsx('flex justify-center betbook-profile-post-module', {
                'items-center': !simplified,
                'betbook-profile-post-active': active
            })}
            {...other}
        >
            <div className="flex betbook-profile-post-module-formater">
                <div className="flex items-center justify-center betbook-profile-post-module-title">{label}</div>
                <div className="flex items-center justify-center betbook-profile-post-module-box">
                    <div className={simplified ? simplifiedProfileClass : profileClass}>{count}</div>
                </div>
            </div>
            {simplified ? null : (
                <div className="betbook-profile-arrow-box">
                    <BetbookProfileArrow />
                </div>
            )}
        </RouteLink>
    );
};

export default ProfilePost;
